/**
 * Halation.
 *
 * Bloom models scattering in the lens and in the eye. Halation models light punching
 * through the phosphor layer, bouncing off the rear of the glass and lighting a much
 * wider, much softer ring — warm, because long wavelengths survive the round trip best.
 * Different phenomenon, so stacking it on the bloom chain is not redundant.
 *
 * Runs at an eighth of buffer resolution off a mid bloom level: five draws over a few
 * thousand pixels. Switched off at §14.6 rung 7 (AMD-2).
 */

/** Four-tap box downsample onto the halation working resolution. */
export const HALATION_DOWN_FRAG = /* glsl */ `
precision highp float;

uniform sampler2D tSource;
uniform vec2 uTexel;

in vec2 vUv;
out vec4 fragColor;

void main() {
  vec3 sum =
      texture(tSource, vUv + uTexel * vec2(-1.0, -1.0)).rgb
    + texture(tSource, vUv + uTexel * vec2( 1.0, -1.0)).rgb
    + texture(tSource, vUv + uTexel * vec2(-1.0,  1.0)).rgb
    + texture(tSource, vUv + uTexel * vec2( 1.0,  1.0)).rgb;
  fragColor = vec4(sum * 0.25, 1.0);
}
`;

/**
 * Separable nine-tap gaussian. `uDirection` is the axis in texels, `uRadius` the spacing
 * multiplier — pushing spacing past one texel trades correctness for reach, which at
 * this resolution nobody can see and everybody can afford.
 */
export const HALATION_BLUR_FRAG = /* glsl */ `
precision highp float;

uniform sampler2D tSource;
uniform vec2 uTexel;
uniform vec2 uDirection;
uniform float uRadius;

in vec2 vUv;
out vec4 fragColor;

const float W0 = 0.2270270270;
const float W1 = 0.1945945946;
const float W2 = 0.1216216216;
const float W3 = 0.0540540541;
const float W4 = 0.0162162162;

void main() {
  vec2 step1 = uTexel * uDirection * uRadius;

  vec3 sum = texture(tSource, vUv).rgb * W0;
  sum += (texture(tSource, vUv + step1).rgb + texture(tSource, vUv - step1).rgb) * W1;
  sum += (texture(tSource, vUv + step1 * 2.0).rgb + texture(tSource, vUv - step1 * 2.0).rgb) * W2;
  sum += (texture(tSource, vUv + step1 * 3.0).rgb + texture(tSource, vUv - step1 * 3.0).rgb) * W3;
  sum += (texture(tSource, vUv + step1 * 4.0).rgb + texture(tSource, vUv - step1 * 4.0).rgb) * W4;

  fragColor = vec4(sum, 1.0);
}
`;
